export default __webpack_public_path__ + "static/media/KZ.T.08.2310 black.abab738b.svg";